import { qliroCheckoutApi } from './checkout'

export const qliroApi = {
  checkout: qliroCheckoutApi
}
